import Vue from "vue";
import axios from "axios";
import { JwtHelper } from "@/helpers/utilities/JwtHelper";
import Router from "vue-router";
import { useSettingsStore } from "@/stores/settings";
import { useMeStore } from "@/stores/me";
import { SessionHelper } from "@/helpers/utilities/sessionHelper";

Vue.use(Router);
let i18n;

export const nwpRouter = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/HomeView.vue"),
      props: true
    },
    {
      path: "/tiles/:groupId",
      name: "tiles",
      component: () => import("@/views/HomeView.vue"),
      props: true
    },
    {
      path: "/colabs/:externalShareId?/edit",
      name: "colab",
      component: () => import("@/applications/nordicworkplace/nwp/views/customerSpecifics/sanovo/colabCreateView.vue"),
      props: true
    },
    {
      path: "/colabs/fromproject/:projectId?",
      name: "colabfromproject",
      component: () => import("@/applications/nordicworkplace/nwp/views/customerSpecifics/sanovo/colabCreateView.vue"),
      props: true
    },
    {
      path: "/colabs",
      name: "colabs",
      component: () => import("@/applications/nordicworkplace/nwp/views/customerSpecifics/sanovo/colabView.vue"),
      props: true
    },

    {
      path: "/uchis/:externalShareId?/edit/:tabId?/:itemId?",
      name: "uchi",
      component: () => import("@/applications/nordicworkplace/nwp/views/UCHI/uchiCreateView.vue"),
      props: true
    },
    {
      path: "/uchis/:driveId/:itemId?",
      name: "uchiShared",
      component: () => import("@/applications/nordicworkplace/nwp/views/UCHI/UchiFilelistView.vue"),
      props: true
    },

    {
      path: "/uchis",
      name: "uchis",
      component: () => import("@/applications/nordicworkplace/nwp/views/UCHI/uchiView.vue"),
      props: true
    },

    {
      path: "/udocuments/:driveId?/:itemId?",
      name: "uchidocuments",
      component: () => import("@/applications/nordicworkplace/nwp/UchiDocumentsView.vue"),
      meta: {
        title: "Documents"
      },
      props: route => ({ ...route.params, nctType: "uchi", nctSystem: "uchi", nctIdentifier: "uchi" })
    },
    {
      path: "/documents/:driveId?/:itemId?",
      name: "documents",
      component: () => import("@/views/Documents/DocumentsView.vue"),
      meta: {
        title: "Documents"
      },
      props: true
    },
    {
      path: "/*://*", // catch all routes with a protocol (external links)
      name: "external",
      beforeEnter: to => (window.location.href = to.path.substr(1))
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("@/views/NotFound.vue")
    }
  ]
});

nwpRouter.beforeEach((to, from, next) => {
  // Check for session token
  try {
    const sessionToken = SessionHelper.nctSessionToken();

    if (!sessionToken) {
      return;
    }

    if (to.meta.roles) {
      // Check for authorization for route
      const allowedRoles = to.meta.roles.find(r => nwpRouter.app.$roles[r]);

      if (!allowedRoles) {
        if (nwpRouter.app.$roles.isSuperUser) {
          next({ name: to.meta.redirects.isSuperUser, params: to.params });
        }

        if (nwpRouter.app.$roles.isTeacher) {
          next({ name: to.meta.redirects.isTeacher, params: to.params });
        }

        if (nwpRouter.app.$roles.isStudent) {
          next({ name: to.meta.redirects.isStudent, params: to.params });
        }
      }
    }

    // Lookup default title from store
    const browserTitle = document.title.split(" - ")[0];

    if (browserTitle) {
      // Find nearest route up the tree with a title
      const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.title);

      // If a route with a title was found, set the document (page) title to that value.
      document.title =
        browserTitle + (nearestWithTitle && i18n ? " - " + i18n.t("Routes." + nearestWithTitle.meta.title) : "");
    }
    // Send simple stats
    if (import.meta.env.PROD) {
      const activeInstitutionId = JwtHelper.getInstitutionId(SessionHelper.nctSessionToken());
      axios.post(
        "https://skobostats.azurewebsites.net/api/NavigationEvent",
        {
          UserId: nwpRouter.app?.$skoboUser?.userId,
          InstitutionId: activeInstitutionId,
          ToRoute: to.path,
          FromRoute: from.path,
          Role: nwpRouter.app?.$roles?.isTeacher
            ? "teacher"
            : nwpRouter.app?.$roles?.isSuperUser
            ? "superuser"
            : "student",
          UserAgent: navigator.userAgent,
          Language: navigator.language
        },
        { headers: { "x-functions-key": "eslMWIyl83a57fwj2ge3aG6LPqQyVKeTwH0ulpf4XSrDQVpeqwC4Ow==" } }
      );
    }
    next();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
});

nwpRouter.afterEach(to => {
  const settingsStore = useSettingsStore();
  settingsStore.logEndpoints.forEach(endpoint => {
    if (to.path.startsWith(endpoint)) {
      const meStore = useMeStore();
      meStore.logEvent(to.path);
    }
  });
});

/**
 * Set translation
 * @param { object } i i18n translation object
 */
export function setTranslater(i) {
  i18n = i;
}
